<h1 class="title text-hard-green" mat-dialog-title>Abrir Chamado</h1>
<form [formGroup]="form" (ngSubmit)="submit()">
  <div mat-dialog-content *ngIf="status == 'W'">
    <mat-form-field appearance="outline" class="full-width">
      <input
        matInput
        type="email"
        formControlName="email"
        placeholder="exemplo@email.com"
        required
        (blur)="searchUser()"
      >
      <!-- [(ngModel)]="email" -->
      <mat-label>Qual é o seu email?</mat-label>
    </mat-form-field>

    <br/>

    <mat-form-field fxFill appearance="outline">
      <mat-select
        formControlName="type"
      >
        <!-- [(ngModel)]="type" -->
        <mat-option value="I">Incidente</mat-option>
        <mat-option value="D">Defeito</mat-option>
        <mat-option value="P">Problema</mat-option>
        <mat-option value="A">Requisição de alteração</mat-option>
      </mat-select>
      <mat-label>Tipo do Chamado</mat-label>
    </mat-form-field>

    <div *ngIf="loading" fxLayoutAlign="center center" style="margin-bottom: 20px;">
      <mat-spinner diameter="30"></mat-spinner>
    </div>

    <mat-form-field *ngIf="!registered" appearance="outline" class="full-width">
      <input
        matInput
        type="text"
        formControlName="name"
        required
        placeholder="Nome Completo"
      >
        <!-- [(ngModel)]="name" -->
      <mat-label>Qual é o seu nome completo?</mat-label>
    </mat-form-field>

    <mat-form-field *ngIf="!registered" appearance="outline" class="full-width">
      <input
        matInput
        required
        mask="(00)000000000"
        formControlName="mobile"
        placeholder="(27) 9 9999-9999"
      >
        <!-- [(ngModel)]="mobile" -->
      <mat-label>Qual é o seu celular?</mat-label>
    </mat-form-field>

    <mat-form-field *ngIf="!registered" appearance="outline" class="full-width">
      <input
        matInput
        type="password"
        formControlName="password"
        required
        placeholder="Uma senha segura"
      >
        <!-- [(ngModel)]="mobile" -->
      <mat-label>Defina uma senha de acesso</mat-label>
    </mat-form-field>

    <label class="title">Descreva abaixo o ocorrido:</label>
    <ckeditor
      fxFill
      [config]="{
        toolbar: [
          'heading',
          '|',
          'bold',
          'italic',
          '|',
          'bulletedList',
          'numberedList',
          '|',
          'undo',
          'redo'
        ]
      }"
      [editor]="entryEditor"
      formControlName="description"
    ></ckeditor>
    <!-- [(ngModel)]="description" -->
  </div>

  <div *ngIf="status == 'P'" fxLayoutAlign="center center" style="margin-bottom: 20px;">
    <mat-spinner diameter="30"></mat-spinner>
  </div>

  <div *ngIf="status == 'E'" fxLayoutAlign="center center" style="margin-bottom: 20px;">
    <h3 class="text-red">Erro ao criar o chamado.</h3>
  </div>

  <div *ngIf="status == 'S'" fxLayout="column" fxLayoutAlign="center center" style="margin-bottom: 20px;">
    <h2>Chamado criado: <span class="text-green">#{{ call.number }}</span></h2>
    <h4>Faça login com o email e a senha utilizados na abertura do primeiro chamado para acompanhar o andamento do mesmo.</h4>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close color="warn">Fechar</button>
    <button mat-raised-button *ngIf="status == 'W' || status == 'E'" type="submit" color="primary">Abri chamado</button>
  </div>
</form>
